module.exports = __webpack_public_path__ + "static/img/wxscr3.fde1416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxscr3.png
// module id = qQsP
// module chunks = 1